/*
 * Ollie in the site search (Industrial Supplies Co).
 * - The header search's live results (Warehouse theme: form.search-bar, results in .search-bar__results) get an
 *   "Ask Ollie" row on top of every set of results, and a bigger invitation when nothing matches.
 * - Questions typed into the search ("which hinges for a 3m gate?", "key clamp tee for 48.3mm tube") open
 *   Ollie instead of a results page; product searches ("horse mats 18mm") still go to the normal search.
 * - The search results page gets an Ollie box under the heading (and a stronger one when nothing is found).
 * Loaded by snippets/ollie.liquid after ollie.js. Everything waits for window.OllieChat.
 */
(function () {
  'use strict';
  var QUESTION = /^(how|what|whats|what's|which|why|when|where|who|can|could|do|does|did|is|are|should|will|would|i|im|i'm|my|we|our|help|need|recommend|best|tell|explain|advice|difference|compare|price|quote|cost)\b/i;

  function isQuestion(q) {
    q = (q || '').trim();
    if (!q) return false;
    if (q.indexOf('?') !== -1) return true;
    if (QUESTION.test(q)) return true;
    // Long phrases are usually a job description ("sheet for a machine guard that gets hit by swarf"),
    // short ones are product searches ("horse mats 18mm").
    return q.split(/\s+/).length >= 7;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function ollie() { return window.OllieChat; }
  function ask(q, source, input) {
    var a = ollie();
    if (!a) return false;
    closeDropdown(input);
    a.open(q, source);
    return true;
  }

  var forms = [].slice.call(document.querySelectorAll('form.search-bar'));
  function inputOf(form) { return form.querySelector('input[name="q"]'); }
  // Where each search shows its live results.
  // Warehouse theme: live results render inside the form's .search-bar__results (the inner list is replaced on each search).
  function panelOf(form) { return form.querySelector('.search-bar__results'); }
  function listOf(panel) { return panel.querySelector('.search-bar__results-inner') || panel; }
  function noMatches(panel) {
    return !!panel.querySelector('.search-bar__empty-text, .search-bar__empty') ||
      (!panel.querySelector('a[href*="/products/"], a[href*="/collections/"]') && /no match|no result|nothing found/i.test(panel.textContent));
  }

  function closeDropdown(input) {
    if (!input) return;
    input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    input.blur();
  }

  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9zM19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9z"/></svg>';
  var MIC = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';

  // ---------- "Ask Ollie" row in the search panels ----------
  function ollieRow(q, none) {
    var title = none ? 'No exact match? Ask Ollie' : 'Ask Ollie: “' + esc(q) + '”';
    var sub = none ? 'Tell him the job and the size: he’ll pick the right parts and price them'
      : 'Our AI industrial supplies specialist picks the right product, size and quantity in seconds';
    return '<button type="button" class="ollie-sr' + (none ? ' ollie-sr--big' : '') + '" data-ollie-sr="' + esc(q) + '">' +
      '<span class="ollie-sr__av" aria-hidden="true">O</span>' +
      '<span class="ollie-sr__txt"><b>' + title + '</b><small>' + sub + '</small></span>' +
      '<span class="ollie-sr__go" aria-hidden="true">' + SPARK + '</span></button>';
  }
  function decorate(form) {
    var input = inputOf(form), panel = panelOf(form), q = input ? input.value.trim() : '';
    if (!panel || q.length < 2 || !panel.firstElementChild) return;
    var none = noMatches(panel);
    var row = panel.querySelector('.ollie-sr');
    if (row && row.getAttribute('data-ollie-sr') === q && row.classList.contains('ollie-sr--big') === none) return;
    if (row) row.remove();
    listOf(panel).insertAdjacentHTML('afterbegin', ollieRow(q, none));
  }
  forms.forEach(function (form) {
    var panel = panelOf(form);
    if (!panel) return;
    var pending = 0;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(function () { decorate(form); }, 30); })
      .observe(panel, { childList: true, subtree: true });
  });

  // Window capture: runs before any of the theme's own handlers (theme scripts may stop submit and click
  // events at the form).
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ollie-sr]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var q = b.getAttribute('data-ollie-sr');
    if (b.classList.contains('ollie-sr--big') && q) q = 'Find me the right product for: ' + q;
    var form = b.closest('form.search-bar');
    ask(q || null, 'search_row', form ? inputOf(form) : null);
  }, true);

  // ---------- questions typed into the search open Ollie ----------
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || forms.indexOf(form) < 0) return;
    var input = inputOf(form), q = input ? input.value.trim() : '';
    if (!isQuestion(q) || !ollie()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: 'search_question', sn_source: 'ollie' }); } catch (err) {}
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    ask(q, 'search_question', input);
  }, true);

  // ---------- search results page ----------
  function searchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q || document.querySelector('.ollie-sp')) return;
    var h1 = document.querySelector('main h1');
    var host = h1 && (h1.closest('header, .page-header, .section__header, .page__header') || h1);
    if (!host) return;
    var none = !document.querySelector('main a[href*="/products/"]');
    var box = document.createElement('section');
    box.className = 'ollie-sp' + (none ? ' ollie-sp--none' : '');
    var lead = none ? 'No exact match for “' + esc(q) + '”, but Ollie can help'
      : 'Not sure which of these is right for your job?';
    var chips = none ? ['Find me the right product for: ' + q, 'Can you cut it to my size?']
      : ['Which of these is best for my job?', 'How much do I need for my area?', 'Can you cut it to my length?'];
    box.innerHTML = '<span class="ollie-sp__av" aria-hidden="true">O</span><div class="ollie-sp__body">' +
      '<b class="ollie-sp__lead">' + lead + '</b>' +
      '<p>Ask Ollie, our AI industrial supplies specialist. Tell him the job and the size and he’ll pick the right product, work out how much and put it in your basket.</p>' +
      '<div class="ollie-sp__chips">' + chips.map(function (c) {
        var full = c.indexOf(q) === -1 ? c + ' (I searched for “' + q + '”)' : c;
        return '<button type="button" class="ollie-sp__chip" data-ollie-sr="' + esc(full) + '">' + esc(c) + '</button>';
      }).join('') + '<button type="button" class="ollie-sp__talk" data-ollie-talk>' + MIC + 'Talk to Ollie</button></div></div>';
    host.parentNode.insertBefore(box, host.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ollie-talk]');
    if (!t || !ollie()) return;
    e.preventDefault();
    ollie().talk('search_page');
  });

  function ready() { searchPage(); }
  // ollie.js is deferred before this file, so OllieChat exists by now; wait a moment if it doesn't.
  function start(tries) { if (ollie() || tries > 40) ready(); else setTimeout(function () { start(tries + 1); }, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(0); }); else start(0);
})();
